
$('.im-marker__trigger').on('click',function(e){
    const mapContainer = $(this).closest('.interactive-map');
    const mapMarker = $(this).closest('.im-marker');
    mapContainer.find('.im-popup').not(mapMarker.find('.im-popup')).removeClass('show');
    mapMarker.find('.im-popup').toggleClass('show');
    e.stopPropagation();
});

$('.im-popup').on('click',function (e){
    e.stopPropagation();
});
$('.im-popup__close-btn').on('click',function (e){
    const mapMarker = $(this).closest('.im-marker');
    mapMarker.find('.im-popup').removeClass('show');
});
$('body').on('click',function (){
    $('.im-popup').removeClass('show');
});
